import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
//icons
import { FaEdit } from 'react-icons/fa';
import { AiFillDelete, AiOutlineEye } from 'react-icons/ai';
import { GiBroom } from 'react-icons/gi';
import { BsSearch } from 'react-icons/bs';
//api
import { getAllBooksOfTheMonth } from 'api/libelista';
//components
import CustomInput from 'components/backoffice/customInput';
import CustomTable from 'components/backoffice/customTable';
import DropdownIcons from 'components/backoffice/dropDownIcons';
import ButtonCustom from 'components/backoffice/buttonCustom';

const colsBooksOfMonthPosts = ['Título', ''];

const BooksOfMonthPosts = () => {
  const navigate = useNavigate();
  const [listBooksOfMonthPosts, setListBooksOfMonthPosts] = useState([]);
  const [noResults, setNoResults] = useState(false);
  const [totalPages, setTotalPages] = useState(null);
  const [isActiveSearch, setIsActiveSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const query = {
    search: '',
    page: 1,
    page_size: 10,
  };
  const searchQuery = new URLSearchParams(query);
  const queryString = searchQuery.toString();

  const getListBooksOfMonthPosts = async () => {
    setIsLoading(true);
    const { data, status } = await getAllBooksOfTheMonth(queryString);
    if (status === 200 && data?.results.length > 0) {
      setListBooksOfMonthPosts(data?.results);
      setNoResults(false);
    } else {
      setListBooksOfMonthPosts([]);
      setNoResults(true);
    }
    setIsLoading(true);
  };

  useEffect(() => {
    getListBooksOfMonthPosts();
  }, []);

  const handleClear = () => {
    setNoResults(false);
    navigate('/intranet/books-of-the-month-posts');
  };

  return (
    <div className="h-100 ml-70">
      <div className="d-flex mt-3 justify-content-between">
        <h1 className="text-light mt-5">Libros del mes</h1>
      </div>

      <div className="d-flex my-5">
        <CustomInput
          //handleSubmit={(e) => handleSubmit(e)}
          placeholder="Buscar por nombre "
          icon={<BsSearch color="#161A25" className="icon-search" />}
          type={'search'}
        />
        <ButtonCustom onClick={handleClear} color="terciary">
          <GiBroom />
        </ButtonCustom>
      </div>
      <CustomTable cols={colsBooksOfMonthPosts} noResults={noResults} className="custom-table">
        {listBooksOfMonthPosts &&
          listBooksOfMonthPosts.map((listBooksOfMonthPost, index) => {
            return (
              <tr key={listBooksOfMonthPosts.id}>
                <td>{listBooksOfMonthPost.title}</td>
                <td className=" item-dropdown text-end">
                  <DropdownIcons idItem={index} />
                </td>
              </tr>
            );
          })}
      </CustomTable>
    </div>
  );
};

export default BooksOfMonthPosts;
